import React, { useState, useEffect } from 'react';

// Banner pictures were taken from here: https://www.vecteezy.com/free-photos/programmers?license-free=true

// Put the imported images into an array
const data = [
    {
        banner: "/images/top_banner_4_r1.webp",
        text: "IT, Ecommerce and Content expertise"
    },
    {
        banner: "/images/top_banner_5_r1.webp",
        text: "Taxonomy and Data Structures"
    },
    {
        banner: "/images/top_banner_6_r1.webp",
        text: "Ecommerce solutions"
    },
    {
        banner: "/images/top_banner_8_r1.webp",
        text: "Products feed management"
    },
    {
        banner: "/images/top_banner_9_r1.webp",
        text: "Development and IT services"
    },
]

export default function BannerCarousel() {

    const [currentIndex, setCurrentIndex] = useState(0);

    const [isVisible, setIsVisible] = useState(false);


    useEffect(() => {

        const intervalId = setInterval(() => {
            // Update the index to the next image in the array, looping back to the start if the end is reached
            setIsVisible(!isVisible);    // for Banner itself to slide in
            setCurrentIndex(prevIndex => (prevIndex + 1) % data.length);

        }, 5000);   // Change image every 3000 milliseconds (3 seconds)

        // Cleanup function to clear the interval when the component unmounts or the effect re-runs
        setIsVisible(!isVisible);    // for Banner itself to slide in
        return () => clearInterval(intervalId);

    }, [currentIndex])    // The empty dependency array ensures the effect runs only once on mount

    let textClass = `banner-text ${isVisible ? 'visible' : ''}`

    return (
        <div className="banner-block">

            <div>
                <img
                    src={data[currentIndex]['banner']}
                    alt={`Slide ${currentIndex + 1}`}
                    // Add optional styling, e.g., to control size
                    className="banner-img"
                />
            </div>

            <div className={textClass}>
                {data[currentIndex]['text']}
            </div>

        </div>
    )
}


